<hyperkit-typography variant="h5" align="left" color="primary">{{
  this.huntContext.queryPackages.title()
}}</hyperkit-typography>
<hyperkit-tab-bar variant="secondary" mode="underline">
  <hyperkit-tab text="Overview" [selected]="true">
    <hunt-details-editor
      title="Threat Description"
      [value]="this.huntContext.queryPackages.description()"
      (valueChange)="onDescriptionChange($event)"
    >
    </hunt-details-editor>

    <hunt-details-editor
      title="Mitigation Recommendations"
      [value]="this.huntContext.queryPackages.mitigationRecommendations()"
      (valueChange)="onMitigationRecommendationsChange($event)"
    >
    </hunt-details-editor>
  </hyperkit-tab>
  <hyperkit-tab text="Queries & Notes">
    <div class="query-container">
      <div class="env-header">
        <hyperkit-typography variant="h5" align="left" color="primary"
          >Environments</hyperkit-typography
        >
        <hyperkit-tag
          [mode]="'outline'"
          [closable]="false"
          [text]="
            this.huntContext.queryPackages.getNumEnvironments().toString()
          "
        >
        </hyperkit-tag>
      </div>
    </div>

    <hyperkit-accordion
      *ngFor="let env of envs()"
      title="{{ env.name }}"
      [expanded]="true"
    >
      <ng-template #headerTemplate>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
          "
        >
          <div style="display: flex; align-items: center">
            <hyperkit-typography variant="label1" color="primary">{{
              env.name
            }}</hyperkit-typography>
          </div>
        </div>
      </ng-template>
      <div>
        <hyperkit-accordion
          *ngFor="let tool of env.tools"
          title="{{ tool.name }}"
          [expanded]="true"
        >
          <ng-template #headerTemplate>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
              "
            >
              <div style="display: flex; align-items: center; gap: 10px">
                <hyperkit-logo
                  [icon]="getIconForProduct(tool.product)"
                  [size]="'medium'"
                ></hyperkit-logo>
                <hyperkit-typography variant="label1" color="primary">{{
                  tool.name
                }}</hyperkit-typography>
              </div>
              <hyperkit-tag
                [mode]="'outline'"
                [closable]="false"
                [text]="tool?.generatedContent?.Hunt?.length.toString() || '0'"
              >
              </hyperkit-tag>
            </div>
          </ng-template>
          <div>
            <div
              class="content-container"
              *ngFor="let content of tool.generatedContent?.Hunt || []"
            >
              <hyperkit-report-query-header
                [isPivot]="false"
                [category]="content.category"
                [numPivots]="content?.pivots?.length || 0"
              >
              </hyperkit-report-query-header>
              <hyperkit-report-query
                [query]="content.query"
              ></hyperkit-report-query>
              <report-text-block
                *ngIf="content.notes"
                title="Notes"
                variant="h6"
                [value]="content.notes"
              >
              </report-text-block>

              <ng-container *ngFor="let pivot of content.pivots">
                <hyperkit-report-query-header
                  [isPivot]="true"
                  [category]="pivot.category"
                  [parentQuery]="content.category"
                ></hyperkit-report-query-header>
                <hyperkit-report-query
                  [query]="pivot.query"
                ></hyperkit-report-query>
                <report-text-block
                  *ngIf="pivot.notes"
                  title="Notes"
                  variant="h6"
                  [value]="pivot.notes"
                >
                </report-text-block>
              </ng-container>
            </div>
          </div>
        </hyperkit-accordion>
      </div>
    </hyperkit-accordion>
  </hyperkit-tab>
</hyperkit-tab-bar>
